import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Avatar,
  CardMedia,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React, { useState } from "react";
import CommonCardData from "./CommonCardData";
import { CustomPaginationCommon } from "modules/Users/components";
import { ConfirmModal } from "components";
import { useNavigate, useParams } from "react-router-dom";
import { cousresArray } from "constant/data";
import { CategoryCommon, FilterCommon, SortDataCommon } from "components";
import { useAuth } from "context/authContext";

const bgColorBorder = [
  {
    progress: 70,
  },
];
type SelectedValueType =
  | "psychotherapy"
  | "olderAdults"
  | "kids"
  | "healthPsychology"
  | "affirmingAntiRacistTherapy"
  | "neuropsychology"
  | "testing";

const itemsPerPage = 6;
const DiscoverData = ({ allContentsData = [], setAllContentsData }: any) => {
  const { currentUser, isLoggedIn } = useAuth();
  // console.log("DiscoverData", allContentsData);

  const [selectedValue, setSelectedValue] =
    useState<SelectedValueType>("psychotherapy");
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState(1);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const navigate = useNavigate();
  const { userType } = useParams();

  // Filter data with safe access to avoid errors
  const handoutData = Array.isArray(allContentsData)
    ? allContentsData.filter((content: any) => content.type === "handout")
    : [];

  const courseData = Array.isArray(allContentsData)
    ? allContentsData.filter((content: any) => content.type === "course")
    : [];

  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const steps: SelectedValueType[] = [
    "psychotherapy",
    "olderAdults",
    "kids",
    "healthPsychology",
    "affirmingAntiRacistTherapy",
    "neuropsychology",
    "testing",
  ];

  const headers: Record<SelectedValueType, string> = {
    psychotherapy: "Psychotherapy",
    olderAdults: "Older Adults",
    kids: "Kids",
    healthPsychology: "Health Psychology",
    affirmingAntiRacistTherapy: "Affirming/Anti-Racist Therapy",
    neuropsychology: "Neuropsychology",
    testing: "Testing",
  };

  const handleSelectionChange = (value: string) => {
    // Find the matching key from the headers object
    const selectedKey = Object.keys(headers).find(
      (key) => headers[key as SelectedValueType] === value
    );
    if (selectedKey) {
      setSelectedValue(selectedKey as SelectedValueType);
    }
  };

  const handleSeeAllCourse = () => {
    navigate("/best-selling-course");
    // setShowAll(true);
    // Scroll to the top smoothly
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSeeAllHandout = () => {
    navigate("/best-selling-handout");
    // setShowAll(true);
    // Scroll to the top smoothly
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const paginatedData = showAll
    ? cousresArray.slice((page - 1) * itemsPerPage, page * itemsPerPage)
    : cousresArray.slice(0, itemsPerPage);

  const handleLoginConfirm = () => {
    handleConfirmClose();
  };

  const [activeDropdown, setActiveDropdown] = React.useState<number | null>(
    null
  );

  const handleDropdownToggle = (dropdownIndex: number) => {
    setActiveDropdown(activeDropdown === dropdownIndex ? null : dropdownIndex);
  };

  const handleNavigateProfile = (userId: any) => {
    const serializableData = JSON.parse(JSON.stringify(allContentsData));
    // console.log("Navigating with serializable data:", serializableData);
    navigate(`/profile-view/${userId}`, {
      state: { userContents: serializableData },
    });
    window.scrollTo({ top: 0, behavior: "smooth" });

  };

  // Render loading message if allContentsData is empty
  if (!allContentsData?.length) {
    return <Typography>Loading...</Typography>;
  }

  const handleLoginNavigate: () => void = () => {
    navigate("/login");
  };

  return (
    <Box
      px={{ xs: 2, md: "76px" }}
      position={"relative"}
      mt={{ xs: 18, md: 8 }}
    // width={"1038px"}
    // width={{ md: "100%", lg: "1038px", xl: "100%" }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        gap={{ xs: 2, md: 4 }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          gap={4}
          width={{ xs: "100%", md: "451.59px" }}
        >
          <Box
            fontSize={{ xs: "16.49px", md: "44.6px" }}
            fontWeight={700}
            color={"#233F91"}
            lineHeight={{ xs: "19.79px", md: "100%" }}
          >
            Grow your skills and make an impact{" "}
          </Box>
          <Typography
            fontSize={{ xs: "14.55px", md: "22.3px" }}
            fontWeight={400}
            color={"#6C6C6C"}
            lineHeight={{ xs: "17.47px", md: "26.76px" }}
          >
            Make learning and teaching more effective with active participation
            and student collaboration
          </Typography>
          {!isLoggedIn && (
            <Button
              sx={{
                ...styleSheet.startBtn,
                display: { xs: "none", md: "block" },
              }}
              onClick={handleLoginNavigate}
            >
              Get Started
            </Button>
          )}
        </Box>
        <CardMedia
          sx={{
            width: { xs: "100%", md: "430.46px" },
            height: { xs: "199.36px", md: "273.96px" },
            borderRadius: { xs: "6.59px", md: "16.09px" },
            // mx: { xs: 0, md: "80px" },
            mr: { xs: 0, md: 2 },
            objectPosition: "center",
            objectFit: "cover",
          }}
          image="/assets/icons/discoverPic.png"
        />
        {!isLoggedIn && (
          <Button
            sx={{
              ...styleSheet.startBtn,
              display: { xs: "block", md: "none" },
            }}
            onClick={handleLoginNavigate}
          >
            Get Started
          </Button>
        )}
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        pt={"70px"}
      >
        <Box
          //   pt={"44px"}
          fontWeight={700}
          fontSize={{ xs: "18px", md: "33px" }}
          color="#233F91"
          display="flex"
          alignItems="center"
          fontFamily={"Atten Round New"}
        >
          Best Selling in Courses
        </Box>
        {/* {!isLoggedIn && (
          <Box display={"flex"} gap={1} alignItems={"center"} mx={"65px"}>
            <SortDataCommon
              activeDropdown={activeDropdown}
              setActiveDropdown={handleDropdownToggle}
            />

            <CategoryCommon
              activeDropdown={activeDropdown}
              setActiveDropdown={handleDropdownToggle}
            />
            <FilterCommon
              activeDropdown={activeDropdown}
              setActiveDropdown={handleDropdownToggle}
            />
          </Box>
        )} */}
      </Box>

      {/* Scrollable container for mobile screens */}
      {/* 
            <Box
                display="flex"
                gap={1}
                flexWrap={{ xs: 'nowrap', md: 'wrap' }}
                overflow={{ xs: 'auto', md: 'visible' }}
                mt={2}
                sx={{
                    scrollbarWidth: 'none', // Hide scrollbar on Firefox
                    '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar on Chrome, Safari, and Edge
                }}
            >
                {cousresArray[0]?.categoriesData?.map((category, categoryIndex) => (
                    <Button onClick={() => handleSelectionChange(category)} key={categoryIndex}
                        sx={{
                            ...styleSheet.CateBtn,
                            whiteSpace: 'nowrap', // Prevent buttons from wrapping
                            bgcolor: selectedValue === Object.keys(headers).find(key => headers[key as SelectedValueType] === category) ? { xs: "#233F91", md: "#233F91" } : { xs: "#F3F3F3", md: "#fff" },
                            color: selectedValue === Object.keys(headers).find(key => headers[key as SelectedValueType] === category) ? "#fff" : "#233F91",
                            "&:hover": {
                                bgcolor: "#233F91",
                                color: "#fff",
                            },
                        }}
                    >
                        {category}
                    </Button>
                ))}
            </Box> */}

      <Box
        mt={"30px"}
        display="flex"
        overflow={{ xs: "auto", md: "visible" }}
        flexWrap={{ xs: "nowrap", xl: "wrap", md: "wrap" }}
        gap={2}
        // No wrap on mobile
        sx={{
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {(showAll ? courseData : courseData.slice(0, 6)).map(
          (item: any, index: any) => (
            <Box
              key={index}
              flexBasis={{
                xs: "90%",
                sm: "calc(50% - 2.5px)",
                md: "calc(32% - 3.33px)",
              }} // Adjust flex basis for mobile
              mb={{ xs: 2, md: 3 }}
              mx={{ xs: "auto", md: "0" }} // Center the card on mobile
              sx={{
                minWidth: {
                  xs: "90%",
                  sm: "calc(50% - 2.5px)",
                  md: "calc(32% - 3.33px)",
                },
              }} // Ensure cards take full width on mobile
            >
              <CommonCardData
                title={item.title}
                category={item.category}
                summary={item.summary}
                author={`${item?.userData?.firstName || ""} ${item?.userData?.lastName || ""
                  }`}
                profilePicture={item?.userData?.profileUrl}
                createdAt={item.createdAt}
                sourceOfKnowledge={item.sourceOfKnowledge}
                type={item.type}
                price={item.price}
                coverPhotoUrl={item.coverPhotoUrl}
                onClick={() => navigate(`/discover/${item.id}`)}
                goToProfile={() => handleNavigateProfile(item?.userData?.id)}
              />
            </Box>
          )
        )}
      </Box>

      {/* </Grid> */}

      <ConfirmModal
        title=""
        subtitle="Figma ipsum component variant main layer. Distribute link object effect create editor flatten link. Asset create bullet library figma vector edit move pen slice. Component flows flows team effect pencil main bullet component. Hand export project arrange pencil selection edit background background. Library align."
        cancelText="Register"
        confirmText="Log In"
        isLoading={false}
        onCancel={handleConfirmClose}
        onConfirm={handleLoginConfirm}
        isConfirmModal={confirmOpen}
        warning="Login Required to Continue"
      />
      {/* {isLoggedIn && ( */}
      <Box
        display={{ xs: "none", md: "flex" }}
        gap={2}
        position={"relative"}
        alignItems={"center"}
        justifyContent={"end"}
      // mr={"65px"}
      >
        {/* <Box
          width={"82%"}
          height={"10px"}
          bgcolor="#E0E0E0"
          borderRadius={"15px"}
          position="relative"
        >
          <Box
            width={`${bgColorBorder[0].progress}%`}
            bgcolor="#233F91"
            height={8}
            borderRadius={4}
            position="absolute"
          />
        </Box> */}

        <Button
          onClick={handleSeeAllCourse}
          sx={{
            display: "flex",
            gap: 1,
            fontSize: "18px",
            fontWeight: 700,
            color: "#233F91",
          }}
        >
          See All
          <KeyboardArrowRightIcon />
        </Button>
      </Box>
      {/* // )} */}
      {/* /// display mobile screen button /// */}
      <Box
        display={{ xs: "flex", md: "none" }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Button
          onClick={handleSeeAllCourse}
          sx={{
            display: "flex",
            gap: 1,
            p: "8px 20px 8px 20px",
            fontSize: "14px",
            borderRadius: "10px",
            fontWeight: 700,
            height: "48px",
            color: "#fff",
            bgcolor: "#233F91",
          }}
        >
          See All Courses
        </Button>
      </Box>

      {/* /// second data card start /// */}

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        pt={"70px"}
      >
        <Box
          //   pt={"44px"}
          fontWeight={700}
          fontSize={{ xs: "18px", md: "33px" }}
          color="#233F91"
          display="flex"
          alignItems="center"
          fontFamily={"Atten Round New"}
        >
          Best Selling in Handout
        </Box>
        {/* {!isLoggedIn && (
          <Box display={"flex"} gap={1} alignItems={"center"} mx={"65px"}>
            <SortDataCommon
              activeDropdown={activeDropdown}
              setActiveDropdown={handleDropdownToggle}
            />

            <CategoryCommon
              activeDropdown={activeDropdown}
              setActiveDropdown={handleDropdownToggle}
            />
            <FilterCommon
              activeDropdown={activeDropdown}
              setActiveDropdown={handleDropdownToggle}
            />
          </Box>
        )} */}
      </Box>

      {/* Scrollable container for mobile screens */}
      {/* 
            <Box
                display="flex"
                gap={1}
                flexWrap={{ xs: 'nowrap', md: 'wrap' }}
                overflow={{ xs: 'auto', md: 'visible' }}
                mt={2}
                sx={{
                    scrollbarWidth: 'none', // Hide scrollbar on Firefox
                    '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar on Chrome, Safari, and Edge
                }}
            >
                {cousresArray[0]?.categoriesData?.map((category, categoryIndex) => (
                    <Button onClick={() => handleSelectionChange(category)} key={categoryIndex}
                        sx={{
                            ...styleSheet.CateBtn,
                            whiteSpace: 'nowrap',
                            bgcolor: selectedValue === Object.keys(headers).find(key => headers[key as SelectedValueType] === category) ? { xs: "#233F91", md: "#233F91" } : { xs: "#F3F3F3", md: "#fff" },
                            color: selectedValue === Object.keys(headers).find(key => headers[key as SelectedValueType] === category) ? "#fff" : "#233F91",
                            "&:hover": {
                                bgcolor: "#233F91",
                                color: "#fff",
                            },
                        }}
                    >
                        {category}
                    </Button>
                ))}
            </Box>
*/}

      <Box
        mt={"30px"}
        display="flex"
        overflow={{ xs: "auto", md: "visible" }} // Scrollable on mobile
        flexWrap={{ xs: "nowrap", md: "wrap" }} // No wrap on mobile
        gap={2}
        sx={{
          scrollbarWidth: "none", // Hide scrollbar on Firefox
          "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar on Chrome, Safari, and Edge
        }}
      >
        {(showAll ? handoutData : handoutData.slice(0, 6)).map(
          (item, index) => (
            <Box
              key={index}
              flexBasis={{
                xs: "90%",
                sm: "calc(50% - 2.5px)",
                md: "calc(32% - 3.33px)",
              }} // Adjust flex basis for mobile
              mb={{ xs: 2, md: 3 }}
              mx={{ xs: "auto", md: "0" }} // Center the card on mobile
              sx={{
                minWidth: {
                  xs: "90%",
                  sm: "calc(50% - 2.5px)",
                  md: "calc(32% - 3.33px)",
                },
              }} // Ensure cards take full width on mobile
            >
              <CommonCardData
                title={item.title || ""}
                category={item.category || []}
                summary={item.summary || ""}
                // author={`${currentUser?.userInfo?.firstName || ""} ${
                //   currentUser?.userInfo?.lastName || ""
                // }`.trim()}
                author={`${item?.userData?.firstName || ""} ${item?.userData?.lastName || ""
                  }`}
                profilePicture={item?.userData?.profileUrl}
                createdAt={item.createdAt || ""}
                sourceOfKnowledge={item.sourceOfKnowledge || ""}
                type={item.type || ""}
                price={item.price || ""}
                coverPhotoUrl={item.coverPhotoUrl || ""}
                // profilePicture={currentUser?.userInfo?.profileUrl}
                onClick={() => navigate(`/discover/${item.id}`)}
                goToProfile={() => handleNavigateProfile(item?.userData?.id)}
              />
            </Box>
          )
        )}
      </Box>
      <Box>
        {!showAll && (
          <>
            <Box
              display={{ xs: "none", md: "flex" }}
              gap={2}
              position={"relative"}
              alignItems={"center"}
              justifyContent={"end"}
            // mr={"65px"}
            >
              {/* <Box
                width={"82%"}
                height={"10px"}
                bgcolor="#E0E0E0"
                borderRadius={"15px"}
                position="relative"
              >
                <Box
                  width={`${bgColorBorder[0].progress}%`}
                  bgcolor="#233F91"
                  height={8}
                  borderRadius={4}
                  position="absolute"
                />
              </Box> */}
              <Button
                onClick={handleSeeAllHandout}
                sx={{
                  display: "flex",
                  gap: 1,
                  fontSize: "18px",
                  fontWeight: 700,
                  color: "#233F91",
                }}
              >
                See All
                <KeyboardArrowRightIcon />
              </Button>
            </Box>
            <Box
              display={{ xs: "flex", md: "none" }}
              alignItems={"center"}
              justifyContent={"center"}
              pb={{ xs: 4, md: 0 }}
            >
              <Button
                onClick={handleSeeAllHandout}
                sx={{
                  display: "flex",
                  gap: 1,
                  p: "8px 20px 8px 20px",
                  fontSize: "14px",
                  borderRadius: "10px",
                  fontWeight: 700,
                  height: "48px",
                  color: "#fff",
                  bgcolor: "#233F91",
                }}
              >
                See All Handouts
              </Button>
            </Box>
          </>
        )}
        {!showAll ? null : (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignContent={"center"}
            m={5}
          >
            <CustomPaginationCommon
              count={Math.ceil(cousresArray.length / itemsPerPage)}
              page={page}
              rowsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DiscoverData;

const styleSheet = {
  CateBtn: {
    border: "1.5px solid #233F91",
    color: "#233F91",
    borderRadius: "15px",
    fontSize: { xs: "14px", md: "18px" },
    fontWeight: 700,
    minWidth: "auto",
    height: "44px",
    padding: "11px, 13px, 11px, 13px",
    // overflow: 'hidden',
  },
  startBtn: {
    color: "#fff",
    bgcolor: "#233F91",
    width: "110px",
    height: "44px",
    borderRadius: "9.23px",
    fontSize: "13px",
    fontWeight: 700,
    "&:hover": {
      bgcolor: "#233F91",
      color: "#fff",
    },
  },
};
